"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var is_nil_1 = require("./is-nil");
exports.default = (function (value) {
    if (is_nil_1.default(value))
        return '';
    return value.toString();
});
//# sourceMappingURL=to-string.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/lib/to-string.js
// module id = 319
// module chunks = 37